/* J.Lore PDP controller — charm gallery + two-line upsell build */
(function () {
  const root = document.querySelector('[data-jl-pdp]');
  if (!root) return;

  const form = root.querySelector('#jl-product-form');
  const variantInput = root.querySelector('#jl-variant-id');
  const priceTag = root.querySelector('#jl-price-tag');
  const mobilePrice = root.querySelector('#jl-mb-price');
  const qtyNum = root.querySelector('#jl-q-num');
  const qtyInput = root.querySelector('#jl-qty-input');
  const colorName = root.querySelector('#jl-color-name');
  const charmName = root.querySelector('#jl-charm-name');
  const specTrim = root.querySelector('#jl-spec-trim');
  const cutoutShot = root.querySelector('#jl-cutout-shot');
  const heroShot = root.querySelector('#jl-hero-shot');
  const leatherShot = root.querySelector('#jl-leather-shot');
  const addBtn = root.querySelector('#jl-add-btn');
  const mbAdd = root.querySelector('#jl-mb-add');
  const mobileBar = root.querySelector('#jl-mobile-bar');
  const galleryThumbs = root.querySelector('#jl-gallery-thumbs');
  const galleryMainShot = root.querySelector('#jl-gallery-main-shot');
  const galleryMain = root.querySelector('.jl-gallery-main');
  const galleryDots = root.querySelector('#jl-gallery-dots');
  const galleryActiveTag = root.querySelector('#jl-gallery-active-tag');
  const MOBILE_MAX = 749;

  function openCartDrawer() {
    function tryOpen() {
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (!cartDrawer) return false;
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        return true;
      }
      if (typeof cartDrawer.showDialog === 'function') {
        cartDrawer.showDialog();
        return true;
      }
      return false;
    }
    if (tryOpen()) return;
    customElements.whenDefined('cart-drawer-component').then(tryOpen);
  }
  const colorOptionIndex = root.dataset.colorOptionIndex != null
    ? Number(root.dataset.colorOptionIndex)
    : 0;
  // Set when Charm is a real Shopify variant option (Color x Charm combos)
  const charmOptionIndex = root.dataset.charmOptionIndex != null
    ? Number(root.dataset.charmOptionIndex)
    : null;
  // Set when Charm Color is a third variant option (Color x Charm x Charm Color)
  const charmColorOptionIndex = root.dataset.charmColorOptionIndex != null
    ? Number(root.dataset.charmColorOptionIndex)
    : null;
  const charmColorWrap = root.querySelector('#jl-charm-color-wrap');
  const charmColorName = root.querySelector('#jl-charm-color-name');

  let productData = {};
  let variantsData = [];
  let variantImagesMap = {};
  let charmCombosMap = {};
  try {
    productData = JSON.parse(document.getElementById('jl-product-json')?.textContent || '{}');
  } catch (e) {
    productData = {};
  }
  try {
    variantsData = JSON.parse(document.getElementById('jl-variants-json')?.textContent || '[]');
  } catch (e) {
    variantsData = [];
  }
  try {
    variantImagesMap = JSON.parse(document.getElementById('jl-variant-images-json')?.textContent || '{}');
  } catch (e) {
    variantImagesMap = {};
  }
  try {
    charmCombosMap = JSON.parse(document.getElementById('jl-charm-combos-json')?.textContent || '{}');
  } catch (e) {
    charmCombosMap = {};
  }
  let comboMediaMap = {};
  let charmProductsMap = {};
  try {
    comboMediaMap = JSON.parse(document.getElementById('jl-combo-media-json')?.textContent || '{}');
  } catch (e) {
    comboMediaMap = {};
  }
  try {
    charmProductsMap = JSON.parse(document.getElementById('jl-charm-products-json')?.textContent || '{}');
  } catch (e) {
    charmProductsMap = {};
  }

  const defaultHeroSrc = heroShot?.getAttribute('src') || '';
  const defaultCutoutSrc = cutoutShot?.getAttribute('src') || '';

  const tintMap = {
    camel: {
      filter: 'none',
      trim: 'Camel pebbled leather',
      leatherClass: ''
    },
    black: {
      filter: 'saturate(.45) brightness(.5) hue-rotate(-12deg)',
      trim: 'Black pebbled leather',
      leatherClass: 'black'
    },
    orange: {
      filter: 'saturate(1.5) hue-rotate(-18deg) brightness(1.02)',
      trim: 'Orange pebbled leather',
      leatherClass: 'orange'
    },
    green: {
      filter: 'saturate(.7) hue-rotate(55deg) brightness(.78)',
      trim: 'Forest pebbled leather',
      leatherClass: 'green'
    },
    periwinkle: {
      filter: 'saturate(.85) hue-rotate(165deg) brightness(.95)',
      trim: 'Periwinkle Blue pebbled leather',
      leatherClass: 'periwinkle'
    }
  };

  const state = {
    charmPrice: 0,
    selectedCharm: 'none',
    charmValue: null,
    charmColorValue: null,
    charmToken: null,
    charmHandle: null,
    charmColorToken: null,
    charmColorLabel: null,
    colorName: '',
    swatchKey: 'camel',
    qty: 1,
    variantId: variantInput?.value
  };

  function isNoneCharm(value) {
    const v = String(value || '').toLowerCase().trim();
    return v === 'none' || v === 'no charm';
  }

  function isNoneCharmColor(value) {
    return isNoneCharm(value);
  }

  function getDefaultCharmColorValue() {
    const sw = root.querySelector('.jl-charm-color-sw');
    return sw?.dataset.charmColorValue || null;
  }

  function normalizeCharmColorValue(value) {
    if (isNoneCharm(state.charmValue)) return null;
    if (!isNoneCharmColor(value)) return value;
    return getDefaultCharmColorValue();
  }

  function syncCharmColorUi(value) {
    const normalized = normalizeCharmColorValue(value);
    state.charmColorValue = normalized;
    if (charmColorName) charmColorName.textContent = normalized || '';

    root.querySelectorAll('.jl-charm-color-sw').forEach(function (sw) {
      const active = sw.dataset.charmColorValue === normalized;
      sw.classList.toggle('active', active);
      sw.setAttribute('aria-checked', active ? 'true' : 'false');
    });
  }

  function toggleCharmColorPicker() {
    if (!charmColorWrap) return;
    charmColorWrap.hidden = isNoneCharm(state.charmValue);
  }

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getCharmComboKey(colorName, charmName) {
    if (!colorName || !charmName || charmName === 'none') return '';
    return slugify(colorName) + '|' + slugify(charmName);
  }

  function getCharmComboImages(colorName, charmName) {
    const key = getCharmComboKey(colorName, charmName);
    if (!key) return null;
    const combo = charmCombosMap[key];
    if (!combo?.hero) return null;
    return {
      hero: normalizeImageUrl(combo.hero),
      cutout: combo.cutout ? normalizeImageUrl(combo.cutout) : null
    };
  }

  function jlTrimSlug() {
    return slugify(state.colorName);
  }

  function jlComboKey() {
    const t = jlTrimSlug();
    if (!state.charmToken || state.charmToken === 'none') return 'combo-' + t + '-none';
    return 'combo-' + t + '-' + state.charmToken + '-' + state.charmColorToken;
  }

  // exact → tolerant (trailing _suffix) → this trim's -none → null
  function jlResolveComboUrl() {
    const key = jlComboKey();
    if (comboMediaMap[key]) return comboMediaMap[key];
    const hit = Object.keys(comboMediaMap).find(function (k) {
      return k === key || k.replace(/_[a-z0-9]+$/, '') === key;
    });
    if (hit) return comboMediaMap[hit];
    const noneKey = 'combo-' + jlTrimSlug() + '-none';
    if (comboMediaMap[noneKey]) return comboMediaMap[noneKey];
    return null;
  }

  function jlUpdateGallery() {
    const url = jlResolveComboUrl();
    if (url && heroShot) {
      setGalleryImage(heroShot, url, productData.title);
      showGalleryImageSlide();
      syncGalleryThumbForUrl(url); // harmless if no matching thumb (combo thumbs are hidden)
    } else {
      refreshGalleryFromSelection(); // existing variant-image / tint fallback
    }
  }

  const moneyFormat = root.dataset.moneyFormat || '{{amount}}';

  function formatMoney(cents, qty) {
    const amount = (cents / 100) * (qty || 1);
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(amount, moneyFormat);
    }
    return 'EGP ' + Math.round(amount).toLocaleString('en-US');
  }

  function getVariantById(id) {
    if (!id) return null;
    return variantsData.find(function (v) {
      return String(v.id) === String(id);
    }) || productData.variants?.find(function (v) {
      return String(v.id) === String(id);
    }) || null;
  }

  function getColorValue(variant) {
    if (!variant) return '';
    if (Array.isArray(variant.options)) {
      return variant.options[colorOptionIndex] || variant.options[0] || '';
    }
    return variant['option' + (colorOptionIndex + 1)] || variant.option1 || '';
  }

  function findVariantByOptions(colorValue, charmValue, charmColorValue) {
    if (charmOptionIndex == null) return null;
    return variantsData.find(function (v) {
      if (!Array.isArray(v.options)) return false;
      const colorMatch = colorValue == null || v.options[colorOptionIndex] === colorValue;
      const charmMatch = charmValue == null || v.options[charmOptionIndex] === charmValue;
      const charmColorMatch = charmColorOptionIndex == null
        || charmColorValue == null
        || v.options[charmColorOptionIndex] === charmColorValue;
      return colorMatch && charmMatch && charmColorMatch;
    }) || null;
  }

  // Try the exact triple first, then progressively relax charm color / charm
  // so a selection always lands on a real variant.
  function resolveVariant(colorValue, charmValue, charmColorValue) {
    const charmColor = isNoneCharm(charmValue) ? null : normalizeCharmColorValue(charmColorValue);
    return findVariantByOptions(colorValue, charmValue, charmColor)
      || findVariantByOptions(colorValue, charmValue, null)
      || findVariantByOptions(colorValue, null, null);
  }

  function findVariantByOption(optionValue) {
    if (!optionValue) return null;
    const fromJson = variantsData.find(function (v) {
      return Array.isArray(v.options) && v.options.some(function (opt) {
        return opt === optionValue;
      });
    });
    if (fromJson) return fromJson;

    if (!productData.variants) return null;
    return productData.variants.find(function (v) {
      return v.available && (v.option1 === optionValue || v.option2 === optionValue || v.option3 === optionValue);
    }) || productData.variants.find(function (v) {
      return v.option1 === optionValue || v.option2 === optionValue || v.option3 === optionValue;
    });
  }

  function updateDisplayedPrice() {
    const variant = getVariantById(state.variantId);
    const base = variant ? variant.price : 0;
    const total = base + state.charmPrice;
    if (priceTag) priceTag.textContent = formatMoney(base, 1);
    const addPriceEl = root.querySelector('#jl-add-price');
    if (addPriceEl) addPriceEl.textContent = formatMoney(total, state.qty);
    if (mobilePrice) mobilePrice.textContent = formatMoney(total, state.qty);
  }

  function updateAvailability(variant) {
    if (!addBtn || !variant) return;
    if (variant.available) {
      addBtn.disabled = false;
      if (!addBtn.querySelector('#jl-add-price')) {
        addBtn.innerHTML = 'Add to Bag — <span id="jl-add-price"></span>';
      }
    } else {
      addBtn.disabled = true;
      addBtn.textContent = 'Sold Out';
    }
    if (mbAdd) mbAdd.disabled = !variant.available;
  }

  function applyColorFallback(key, name) {
    const tint = tintMap[key] || tintMap.camel;
    if (specTrim) specTrim.textContent = name ? name + ' pebbled leather' : tint.trim;
    [cutoutShot, heroShot].forEach(function (img) {
      if (!img) return;
      if (defaultHeroSrc && img === heroShot) img.setAttribute('src', defaultHeroSrc);
      if (defaultCutoutSrc && img === cutoutShot) img.setAttribute('src', defaultCutoutSrc);
      img.style.filter = tint.filter;
    });
    if (leatherShot) {
      leatherShot.className = 'jl-ph jl-ph-leather' + (tint.leatherClass ? ' ' + tint.leatherClass : '');
    }
  }

  function normalizeImageUrl(url) {
    if (!url || typeof url !== 'string') return '';
    if (url.startsWith('//')) return window.location.protocol + url;
    return url;
  }

  function setGalleryTag(label, isLight) {
    if (!galleryActiveTag) return;
    galleryActiveTag.textContent = label || '';
    galleryActiveTag.classList.toggle('jl-shot__tag--light', Boolean(isLight));
    galleryActiveTag.hidden = !label;
  }

  function showGalleryImageSlide() {
    if (galleryMainShot) {
      galleryMainShot.hidden = false;
      galleryMainShot.classList.remove('jl-hidden');
    }
    root.querySelectorAll('.jl-gallery-detail').forEach(function (panel) {
      panel.hidden = true;
      panel.classList.add('jl-hidden');
    });
  }

  function showGalleryDetailSlide(detailKey) {
    if (galleryMainShot) {
      galleryMainShot.hidden = true;
      galleryMainShot.classList.add('jl-hidden');
    }
    root.querySelectorAll('.jl-gallery-detail').forEach(function (panel) {
      const isMatch = panel.dataset.detail === detailKey;
      panel.hidden = !isMatch;
      panel.classList.toggle('jl-hidden', !isMatch);
    });
  }

  function setActiveGalleryThumb(thumb) {
    if (!galleryThumbs || !thumb) return;
    galleryThumbs.querySelectorAll('.jl-gallery-thumb').forEach(function (btn) {
      const active = btn === thumb;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    if (galleryDots) {
      const thumbs = [...galleryThumbs.querySelectorAll('.jl-gallery-thumb')];
      const index = thumbs.indexOf(thumb);
      galleryDots.querySelectorAll('.dot').forEach(function (dot, i) {
        const active = i === index;
        dot.classList.toggle('active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
    thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  }

  function syncGalleryThumbForUrl(url) {
    if (!galleryThumbs || !url) return;
    const normalized = normalizeImageUrl(url);
    const match = [...galleryThumbs.querySelectorAll('.jl-gallery-thumb[data-slide-type="image"]')].find(function (btn) {
      return normalizeImageUrl(btn.dataset.fullSrc) === normalized;
    });
    if (match) setActiveGalleryThumb(match);
  }

  function activateGalleryThumb(thumb) {
    if (!thumb) return;
    const slideType = thumb.dataset.slideType || 'image';
    if (slideType === 'detail') {
      showGalleryDetailSlide(thumb.dataset.detail);
      setGalleryTag(thumb.dataset.tag || '', thumb.dataset.tagLight === 'true');
    } else {
      showGalleryImageSlide();
      setGalleryImage(heroShot, thumb.dataset.fullSrc, thumb.dataset.alt);
      setGalleryTag(thumb.dataset.tag || '', thumb.dataset.tagLight === 'true');
    }
    setActiveGalleryThumb(thumb);
  }

  function getVariantImageUrls(variant, overrideUrl) {
    const urls = [];
    const direct = normalizeImageUrl(overrideUrl);
    if (direct) urls.push(direct);

    if (variant?.id != null) {
      const mapped = variantImagesMap[String(variant.id)];
      if (Array.isArray(mapped)) {
        mapped.forEach(function (url) {
          const normalized = normalizeImageUrl(url);
          if (normalized && !urls.includes(normalized)) urls.push(normalized);
        });
      } else if (typeof mapped === 'string' && mapped) {
        const normalized = normalizeImageUrl(mapped);
        if (normalized) urls.push(normalized);
      }
    }

    if (!urls.length && variant) {
      if (typeof variant.featured_image === 'string' && variant.featured_image) {
        urls.push(normalizeImageUrl(variant.featured_image));
      } else if (variant.featured_image?.src) {
        urls.push(normalizeImageUrl(variant.featured_image.src));
      }
    }

    if (!urls.length && variant?.id != null && productData.variants) {
      const fromProduct = productData.variants.find(function (v) {
        return String(v.id) === String(variant.id);
      });
      if (fromProduct?.featured_image?.src) {
        urls.push(normalizeImageUrl(fromProduct.featured_image.src));
      }
    }

    return urls.filter(Boolean);
  }

  function setGalleryImage(img, url, alt) {
    if (!img || !url) return;
    img.removeAttribute('srcset');
    img.src = url;
    img.style.filter = 'none';
    if (alt) img.alt = alt;
  }

  function applyVariantImages(variant, overrideUrl, displayName) {
    const name = displayName || getColorValue(variant);
    const combo = getCharmComboImages(name, state.selectedCharm);
    let urls = [];

    if (combo?.hero) {
      urls = [combo.hero];
      if (combo.cutout) urls.push(combo.cutout);
    } else {
      urls = getVariantImageUrls(variant, overrideUrl);
    }

    if (!urls.length || !heroShot) return false;

    setGalleryImage(heroShot, urls[0], name || variant?.name || productData.title);
    if (cutoutShot) {
      setGalleryImage(cutoutShot, urls[1] || urls[0], name || variant?.name || productData.title);
    }

    showGalleryImageSlide();
    syncGalleryThumbForUrl(urls[0]);
    return true;
  }

  function applyVariant(variant, swatchKey, displayName, imageUrl) {
    if (!variant) return;
    const name = displayName || getColorValue(variant);
    const key = swatchKey || 'camel';

    state.variantId = variant.id;
    state.colorName = name;
    state.swatchKey = key;
    if (variantInput) variantInput.value = variant.id;
    if (colorName) colorName.textContent = name;

    const hasVariantImage = applyVariantImages(variant, imageUrl, name);
    if (!hasVariantImage) {
      applyColorFallback(key, name);
    } else if (specTrim) {
      specTrim.textContent = name + ' pebbled leather';
    }

    if (leatherShot) {
      const tint = tintMap[key] || tintMap.camel;
      leatherShot.className = 'jl-ph jl-ph-leather' + (tint.leatherClass ? ' ' + tint.leatherClass : '');
    }

    updateDisplayedPrice();
    updateAvailability(variant);
  }

  function refreshGalleryFromSelection() {
    const variant = getVariantById(state.variantId);
    const activeSw = root.querySelector('.jl-sw.active:not(.jl-charm-color-sw)');
    const imageUrl = activeSw?.getAttribute('data-image') || '';

    if (variant) {
      applyVariant(variant, state.swatchKey, state.colorName, imageUrl);
      return;
    }

    if (state.colorName && applyVariantImages({ id: state.variantId }, imageUrl, state.colorName)) {
      if (specTrim) specTrim.textContent = state.colorName + ' pebbled leather';
    } else {
      applyColorFallback(state.swatchKey, state.colorName);
    }
  }

  root.querySelectorAll('.jl-sw:not(.jl-charm-color-sw)').forEach(function (sw) {
    sw.addEventListener('click', function () {
      root.querySelectorAll('.jl-sw:not(.jl-charm-color-sw)').forEach(function (s) {
        s.classList.remove('active');
        s.setAttribute('aria-checked', 'false');
      });
      sw.classList.add('active');
      sw.setAttribute('aria-checked', 'true');

      const key = sw.dataset.c;
      const name = sw.dataset.name;
      let imageUrl = sw.getAttribute('data-image') || '';
      let variant = null;

      if (charmOptionIndex != null) {
        // Charm is a real variant option: match this color with the selected charm
        // (and charm color), and let the exact combo variant's own image win over
        // the color-only image.
        variant = resolveVariant(name || sw.dataset.variantValue, state.charmValue, state.charmColorValue);
        if (variant) imageUrl = '';
      }
      if (!variant && sw.dataset.variantId) {
        variant = getVariantById(sw.dataset.variantId);
      }
      if (!variant) {
        variant = findVariantByOption(name) || findVariantByOption(sw.dataset.variantValue);
      }

      if (variant) {
        applyVariant(variant, key, name, imageUrl);
      } else if (imageUrl) {
        if (colorName) colorName.textContent = name;
        if (applyVariantImages({ id: sw.dataset.variantId }, imageUrl, name)) {
          if (specTrim) specTrim.textContent = name + ' pebbled leather';
        } else {
          applyColorFallback(key, name);
        }
      } else {
        if (colorName) colorName.textContent = name;
        applyColorFallback(key, name);
      }

      // Legacy mode: re-resolve the combo image for the new trim
      if (charmOptionIndex == null) {
        state.colorName = name;
        jlUpdateGallery();
      }
    });
  });

  root.querySelectorAll('.jl-charm-opt').forEach(function (opt) {
    opt.addEventListener('click', function () {
      root.querySelectorAll('.jl-charm-opt').forEach(function (o) {
        o.classList.remove('active');
        o.setAttribute('aria-checked', 'false');
      });
      opt.classList.add('active');
      opt.setAttribute('aria-checked', 'true');

      // Real variant option mode: color + charm + charm color resolve one exact variant
      const charmValue = opt.dataset.charmValue;
      if (charmValue != null && charmOptionIndex != null) {
        state.charmValue = charmValue;
        state.charmPrice = 0;
        if (charmName) charmName.textContent = opt.dataset.charmLabel || charmValue;
        toggleCharmColorPicker();
        syncCharmColorUi(state.charmColorValue);

        const variant = resolveVariant(state.colorName || null, charmValue, state.charmColorValue);
        if (variant) {
          applyVariant(variant, state.swatchKey, state.colorName, '');
        }
        return;
      }

      // Legacy mode: charm is a line item property + a real charm product line
      const isNone = opt.dataset.charm === 'none';
      state.charmToken = isNone ? 'none' : (opt.dataset.charmToken || 'none');
      state.charmHandle = isNone ? null : (opt.dataset.charmHandle || null);
      state.charmPrice = isNone ? 0 : (Number(opt.dataset.price) || 0);
      state.selectedCharm = isNone ? 'none' : (opt.dataset.charm || 'none');
      if (charmName) charmName.textContent = isNone ? 'None' : opt.dataset.charm;
      const charmProp = root.querySelector('#jl-charm-property');
      if (charmProp) charmProp.value = isNone ? '' : opt.dataset.charm;

      // progressive disclosure of the charm-color row
      const wrap = root.querySelector('#jl-charm-color-wrap');
      const colorProp = root.querySelector('#jl-charm-color-property');
      const colorNameEl = root.querySelector('#jl-charm-color-name');
      if (wrap) wrap.hidden = isNone;
      if (isNone) {
        state.charmColorToken = null;
        state.charmColorLabel = null;
        if (colorProp) colorProp.value = '';
        if (colorNameEl) colorNameEl.textContent = '';
      } else if (!state.charmColorToken) {
        const sw = root.querySelector('.jl-charm-color-sw');
        if (sw) {
          root.querySelectorAll('.jl-charm-color-sw').forEach(function (s) {
            s.classList.remove('active');
            s.setAttribute('aria-checked', 'false');
          });
          sw.classList.add('active');
          sw.setAttribute('aria-checked', 'true');
          state.charmColorToken = sw.dataset.charmColorToken;
          state.charmColorLabel = sw.dataset.charmColorValue;
          if (colorNameEl) colorNameEl.textContent = state.charmColorLabel;
          if (colorProp) colorProp.value = state.charmColorLabel;
        }
      } else {
        if (colorNameEl) colorNameEl.textContent = state.charmColorLabel;
        if (colorProp) colorProp.value = state.charmColorLabel;
      }

      jlUpdateGallery();
      updateDisplayedPrice();
      const legacyVariant = getVariantById(state.variantId);
      if (legacyVariant) updateAvailability(legacyVariant);
    });
  });

  root.querySelectorAll('.jl-charm-color-sw').forEach(function (sw) {
    sw.addEventListener('click', function () {
      root.querySelectorAll('.jl-charm-color-sw').forEach(function (s) {
        s.classList.remove('active');
        s.setAttribute('aria-checked', 'false');
      });
      sw.classList.add('active');
      sw.setAttribute('aria-checked', 'true');

      const value = sw.dataset.charmColorValue;

      if (charmOptionIndex != null) {
        // variant-option mode (unchanged behavior)
        syncCharmColorUi(value);
        const variant = resolveVariant(state.colorName || null, state.charmValue, state.charmColorValue);
        if (variant) {
          applyVariant(variant, state.swatchKey, state.colorName, '');
        }
        return;
      }

      // legacy token mode
      state.charmColorToken = sw.dataset.charmColorToken;
      state.charmColorLabel = value;
      const colorNameEl = root.querySelector('#jl-charm-color-name');
      const colorProp = root.querySelector('#jl-charm-color-property');
      if (colorNameEl) colorNameEl.textContent = value;
      if (colorProp) colorProp.value = value;
      jlUpdateGallery();
      updateDisplayedPrice();
    });
  });

  const qMinus = root.querySelector('#jl-q-minus');
  const qPlus = root.querySelector('#jl-q-plus');

  function syncQty() {
    if (qtyNum) qtyNum.textContent = state.qty;
    if (qtyInput) qtyInput.value = state.qty;
    updateDisplayedPrice();
    const variant = getVariantById(state.variantId);
    if (variant) updateAvailability(variant);
  }

  if (qMinus) {
    qMinus.addEventListener('click', function () {
      if (state.qty > 1) {
        state.qty -= 1;
        syncQty();
      }
    });
  }
  if (qPlus) {
    qPlus.addEventListener('click', function () {
      if (state.qty < 9) {
        state.qty += 1;
        syncQty();
      }
    });
  }

  // Two-line add to cart: bag line (+ charm product line when a charm is picked).
  // Intercepts the FORM submit so the mobile bar (which clicks the submit button)
  // routes through the same handler.
  if (form) {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const charmActive = charmOptionIndex == null && state.charmToken && state.charmToken !== 'none';

      const bagProps = charmActive
        ? {
            'Charm': root.querySelector('#jl-charm-property')?.value || state.selectedCharm,
            'Charm Color': state.charmColorLabel || ''
          }
        : {};
      const items = [{ id: Number(state.variantId), quantity: state.qty, properties: bagProps }];

      if (charmActive) {
        const cp = charmProductsMap[state.charmToken];
        const cv = cp && cp.variants ? cp.variants[String(state.charmColorLabel).toLowerCase()] : null;
        if (cv && cv.available) {
          items.push({
            id: Number(cv.id),
            quantity: state.qty,
            properties: { '_attached_to': productData.title, '_bag_line': 'true' }
          });
        }
        // if the charm color is OOS, we silently ship the bag only
      }

      if (addBtn) addBtn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!res.ok) throw new Error(await res.text());
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: form.id,
            data: {
              source: 'jlore-product-pdp',
              itemCount: cart.item_count,
              variantId: String(state.variantId)
            }
          }
        }));
        openCartDrawer();
        if (addBtn) addBtn.disabled = false;
      } catch (err) {
        console.error('[jlore] add to cart failed', err);
        if (addBtn) addBtn.disabled = false;
        alert('Could not add to bag — please try again.');
      }
    });
  }

  root.querySelectorAll('.jl-acc-head').forEach(function (head) {
    head.addEventListener('click', function () {
      const acc = head.closest('.jl-acc');
      const body = acc?.querySelector('.jl-acc-body');
      if (!acc || !body) return;
      const open = acc.classList.toggle('open');
      body.style.maxHeight = open ? body.querySelector('.inner')?.scrollHeight + 'px' : '0';
    });
  });

  const openAcc = root.querySelector('.jl-acc.open .jl-acc-body');
  if (openAcc) {
    openAcc.style.maxHeight = openAcc.querySelector('.inner')?.scrollHeight + 'px';
  }

  if (galleryThumbs) {
    if (galleryDots) {
      galleryDots.innerHTML = '';
      galleryThumbs.querySelectorAll('.jl-gallery-thumb').forEach(function (thumb, i) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'dot' + (thumb.classList.contains('is-active') ? ' active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.setAttribute('aria-selected', thumb.classList.contains('is-active') ? 'true' : 'false');
        dot.addEventListener('click', function () {
          activateGalleryThumb(thumb);
        });
        galleryDots.appendChild(dot);
      });
    }

    galleryThumbs.querySelectorAll('.jl-gallery-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateGalleryThumb(thumb);
      });
    });
  }

  if (galleryMain && galleryThumbs) {
    let touchStartX = 0;
    let touchStartY = 0;
    galleryMain.addEventListener('touchstart', function (e) {
      if (window.innerWidth > MOBILE_MAX) return;
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });
    galleryMain.addEventListener('touchend', function (e) {
      if (window.innerWidth > MOBILE_MAX) return;
      const dx = e.changedTouches[0].screenX - touchStartX;
      const dy = e.changedTouches[0].screenY - touchStartY;
      if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) return;
      const thumbs = [...galleryThumbs.querySelectorAll('.jl-gallery-thumb')];
      const current = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
      if (current < 0) return;
      const next = dx < 0
        ? Math.min(current + 1, thumbs.length - 1)
        : Math.max(current - 1, 0);
      if (next !== current) activateGalleryThumb(thumbs[next]);
    }, { passive: true });
  }

  if (heroShot && galleryThumbs) {
    heroShot.addEventListener('load', function () {
      if (window.innerWidth > MOBILE_MAX) return;
      const active = galleryThumbs.querySelector('.jl-gallery-thumb.is-active');
      if (active) {
        active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    });
  }

  if (addBtn && mobileBar) {
    const onScroll = function () {
      if (window.innerWidth > MOBILE_MAX) {
        mobileBar.classList.remove('show');
        return;
      }
      const r = addBtn.getBoundingClientRect();
      const passed = r.bottom < 0 || r.top > window.innerHeight;
      mobileBar.classList.toggle('show', passed);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }
  if (mbAdd && addBtn) {
    mbAdd.addEventListener('click', function () {
      addBtn.click();
    });
  }

  const wishBtn = root.querySelector('#jl-wish-btn');
  if (wishBtn) {
    wishBtn.addEventListener('click', function () {
      const icon = root.querySelector('#jl-wish-icon');
      const saved = wishBtn.classList.toggle('saved');
      if (icon) icon.textContent = saved ? '♥' : '♡';
    });
  }

  const initialVariant = getVariantById(state.variantId);
  if (initialVariant) {
    if (charmOptionIndex != null && Array.isArray(initialVariant.options)) {
      state.charmValue = initialVariant.options[charmOptionIndex] || null;
    }
    if (charmColorOptionIndex != null && Array.isArray(initialVariant.options)) {
      state.charmColorValue = initialVariant.options[charmColorOptionIndex] || null;
    }
    toggleCharmColorPicker();
    syncCharmColorUi(state.charmColorValue);
    const activeSw = root.querySelector('.jl-sw.active:not(.jl-charm-color-sw)');
    const initialImage = charmOptionIndex != null ? '' : (activeSw?.getAttribute('data-image') || '');
    applyVariant(
      initialVariant,
      activeSw?.dataset.c,
      getColorValue(initialVariant),
      initialImage
    );
    // Legacy mode: show this trim's combo hero (e.g. combo-havane-none) on load
    if (charmOptionIndex == null) {
      jlUpdateGallery();
    }
  } else {
    updateDisplayedPrice();
  }
})();
